module.exports = __webpack_public_path__ + "static/media/list-ol.f53f22b9.svg";